import React from "react";
import { UserScreen } from "../../../layouts/user-screen.tsx";
import { FontStyles } from "../../../utils/font-styles.ts";
import { ButtonLink } from "../../../components/buttons/button-link.tsx";

const textStyle = `font-normal ${FontStyles[`body-l`]}`;
export interface ErrorScreenProps {
  accountActive: boolean;
}
export const AccountActivationErrorScreen: React.FC<ErrorScreenProps> = ({ accountActive }) => {
  const message = accountActive
    ? "Your account already seems to be active. If you are unable to login using your password then please contact us and we will resolve the problem as quickly as possible."
    : "Sorry, your activation code is invalid. Please contact us and we will resolve the problem as quickly as possible.";
  return (
    <UserScreen headerText="Account activation" dismissible={false}>
      <div className="flex flex-col relative gap-4.5 md:gap-6 px-4.5 pb-5 pt-2 md:px-7.5 md:pb-7.5 my-7.5">
        <p className={textStyle}>{message}</p>
        <ButtonLink colorVariant="primary" label="Contact us" variant="outlined" href="mailto:support@espc.com" />
        {accountActive && (
          <ButtonLink colorVariant="primary" label="Try logging in" variant="outlined" href="/users/login" />
        )}
      </div>
    </UserScreen>
  );
};
